var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.visible
    ? _c(
        "div",
        { attrs: { "data-test": "loading" } },
        [
          _vm.templateType == _vm.templates.TwoLineAvatarList
            ? _c("LoadingListAvatarTwoLines")
            : _vm.templateType == _vm.templates.Card
            ? _c("LoadingListCard")
            : _vm.templateType == _vm.templates.OrdineDettaglio
            ? _c("LoadingOrdineDettaglio")
            : _vm.templateType == _vm.templates.LavorazioneDettaglio
            ? _c("LoadingLavorazioneDettaglio")
            : _vm.templateType == _vm.templates.CreaSpedizione
            ? _c("LoadingCreaSpedizione")
            : _vm.templateType == _vm.templates.Consumi
            ? _c("LoadingConsumi")
            : _vm.templateType == _vm.templates.DistintaDettaglio
            ? _c("LoadingDistintaDettaglio")
            : _vm.templateType == _vm.templates.ReintegroDettaglio
            ? _c("LoadingReintegroDettaglio")
            : _vm.templateType == _vm.templates.DataTable
            ? _c("LoadingDataTable")
            : _c(
                "div",
                [
                  _c(
                    "v-sheet",
                    {
                      staticClass: "px-3 pt-3 pb-12",
                      attrs: {
                        color: `grey ${
                          _vm.$vuetify.theme.dark ? "darken-2" : "lighten-4"
                        }`,
                      },
                    },
                    [
                      _c("v-skeleton-loader", {
                        staticClass: "mx-auto",
                        attrs: { type: "card", "max-width": "500" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      )
    : _c("div", [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }